module.exports = __webpack_public_path__ + "img/tjlb2.5ba0442a.jpg";